<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/mis_pedidos' }">
          {{ $t("app.modules.orders.title") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ $t("app.modules.orders.details.title") }}
        </el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">
          {{ $t("app.welcome") }} {{ this.$store.state.user.nombre }}
        </h6>
      </el-breadcrumb>
      <td class="col-11"></td>
      <td class="col-2">
        <h7 style="margin-bottom: 0px" class="text-right"
          >{{ this.$store.state.user.cliente.razonSocial }}
        </h7>
      </td>
    </div>
    <div class="col-md-12">
      <h3>
        {{ $t("app.modules.orders.details.title") }}
      </h3>
    </div>
    <card>
      <!--
        numPedidoSAP
        estadoPEdido

        razonSocial

        fechaCreacionPedido
        fechaConfirmacionPedido
        fechaEstimadaEntrega

        ordenCompraCliente

        vendedor
        servicioCliente
        usuarioCliente

        total
      -->
      <div class="row">
        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.business_name") }}</b
          >:
          {{ this.pedido.razonSocial }}
          <br />
          <b>{{ $t("app.modules.orders.headers.delivery_address") }}</b
          >:
          {{ this.detalles[0].direccionEntrega }}
          
        </div>
        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.reference") }}</b
          >:
          {{ this.pedido.idPedido }}
          <br />
          <b>{{ $t("app.modules.orders.headers.order_number") }}</b
          >:
          {{ this.pedido.numPedidoSAP }}
          <br />
          <b>{{ $t("app.modules.orders.headers.status") }}</b>
          <br />
          {{ this.pedido.value }}
        </div>

        <!--
        <div class="col-md-2 float-left">
          <b>Razón social</b>:
          <br />
          {{ this.pedido.razonSocial }}
        </div>
        -->
        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.created_date") }}</b
          >:
          {{ this.pedido.fechaCreacionPedido }}
          <br />
          <b>{{ $t("app.modules.orders.headers.auth_date") }}</b
          >:
          {{
            this.pedido.fechaConfirmacionPedido != "1900-01-01"
              ? this.pedido.fechaConfirmacionPedido
              : ""
          }}
        </div>

        <div class="col-md-2 float-left">
          <!--
          <b>{{ $t("app.modules.orders.headers.salesman") }}</b
          >:
          {{ this.pedido.vendedor }}
          <br />
          -->
          <b>{{ $t("app.modules.orders.headers.customer_service") }}</b
          >:
          {{ this.pedido.servicioCliente }}
        </div>

        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.purchase_order") }}</b> :
          <br />
          {{ this.pedido.ordenCompraCliente }}
        </div>

        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.total") }}</b> :
          <br />
          {{ this.pedido.total | currencyFormat }}
          <br />
          <b>{{ $t("app.modules.orders.headers.money") }}</b
          >:
          {{ this.pedido.moneda }}
        </div>

        <!--
        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.subtotal") }}</b> :
          <br />
          {{ this.pedido.total | currencyFormat }}
          &nbsp;
          {{ this.pedido.moneda }}
        </div>
        -->
      </div>
    </card>
    <div class="col-md-12" v-for="det in this.detalles" :key="det.idPedido">
      <card>
        <div class="col-md-12">
          <!--
          <div class="col-md-2 float-left">
            <img style="width: 50%" :src="[server + det.imagenProducto]" />
          </div>
          -->

          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.products.headers.SAPCode") }}</b> :
            <br />
            {{ det.codigoProducto }}
          </div>


          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.description") }}</b> :
            <br />
            {{ det.descripcionProducto }}
          </div>

          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.quantity") }}</b> :
            <br />
            {{ det.cantidad | numFormat }}
            &nbsp;
            {{ det.unidadMedida }}
          </div>

          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.unitPrice") }}</b> :
            <br />
            {{ det.precioUnitario | currencyFormat }}
            &nbsp;
            {{ det.moneda }}
          </div>

          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.subtotal") }}</b> :
            <br />
            {{ det.total | currencyFormat }}
            &nbsp;
            {{ det.moneda }}
          </div>

          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.delivery_date") }}</b> :
            <br />
            {{ det.fechaEntregaSolicitada | moment("MM-DD-YYYY") }}            
          </div>



          <!--
          <div class="col-md-1 float-left">{{ det.codigoProducto }}</div>
          <div class="col-md-1 float-left">
            <span v-if="$store.state.lang == 'es'">
              {{ det.descripcionProductoEs }}
            </span>
            <span v-else-if="$store.state.lang == 'en'">
              {{ det.descripcionProductoEn }}
            </span>
            <span v-else>
              {{ det.descripcionProducto }}
            </span>
          </div>
          <div class="col-md-1 float-left">
            <b>{{ $t("app.modules.orders.headers.quantity") }}: </b>
            {{ det.cantidad | numFormat }}
          </div>
          <div class="col-md-1 float-left">{{ det.unidadMedida }}</div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.delivery_date") }}: </b>
            {{ det.fechaEntregaSolicitada | moment("YYYY-MM-DD") }}
          </div>
          <div class="col-md-2 float-left">
            <b>{{ $t("app.modules.orders.headers.delivery_address") }}: </b>
            {{ det.direccionEntrega }}
          </div>
          
          <div class="col-md-1 float-left text-center">
            {{ det.total | currencyFormat }}
            &nbsp;
            {{ det.moneda }}
          </div>
          -->

          <!--
          <div class="col-md-1 float-left text-center">
            <verify-permission
              controller="PartidaTracking"
              action="getTrackingPartida"
            >
              <n-button
                v-if="pedido.idEstadoPedido == 2"
                type="primary"
                class="btn btn-sm"
                @click.native="showTracking(det)"
              >
                {{ $t("app.modules.orders.tracking.name") }}
              </n-button>
            </verify-permission>
            <verify-permission
              controller="PedidoDocumento"
              action="getPedidoDocumentos"
            >
              <n-button
                type="secondary"
                class="btn btn-sm btn-outline-secondary"
                @click.native="showDocs(det)"
              >
                {{ $t("app.modules.orders.web.docs") }}
              </n-button>
            </verify-permission>
          </div>
        -->
        </div>
      </card>
    </div>
    <partida-docs />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

Vue.filter("numFormat", numFormat(numeral));

export default {
  components: {
    PartidaDocs: () => import("../components/partidaDocs"),
  },
  computed: {},
  data() {
    return {
      idPedido: 0,
      pedido: {},
      detalles: [],
      server: "",
    };
  },
  created() {
    this.idPedido = this.$route.params.idPedido;
    // console.log(this.idPedido);
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });
    await this.getOrder(this.idPedido);
    await this.getOrderDetail(this.idPedido);
    this.$swal.close();
  },
  methods: {
    ...mapMutations({
      setOrder: "SET_ORDER",
      setDetail: "SET_DETAIL",
    }),
    async getOrder(id) {
      const params = {
        id: parseInt(id),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http.post(route("Pedidos/getPedidoWeb"), params).then(
        async (response) => {
          if (response.body.code === 200) {
            this.pedido = response.body.pedido;
            // console.log(this.pedido);
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(response.body.message);
          }
        },
        (error) => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
          console.error(error);
        }
      );
    },
    async getOrderDetail(id) {
      const params = {
        id: parseInt(id),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http.post(route("Pedidos/getPedidoDetalleWeb"), params).then(
        async (response) => {
          if (response.body.code === 200) {
            this.detalles = response.body.detalles;
            // console.log(this.detalles);
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(response.body.message);
          }
        },
        (error) => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
          console.error(error);
        }
      );
    },
    showTracking(detalle) {
      // console.log(detalle);
      this.setOrder(this.pedido);
      this.setDetail(detalle);
      this.$router.push({ name: "Tracking partida web" });
    },
    showDocs(detalle) {
      EventBus.$emit("partida-docs", {
        detallePedido: detalle,
      });
    },
  },
  filters: {
    currencyFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    },
  },
};
</script>

<style scoped>
.breadcumb {
  margin: 10px 0px 15px 0px;
}
</style>
